import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';
import { CommonService } from 'src/app/service/common.service';
import { Destroy } from 'src/app/service/destroy';
// removed StorageService to avoid global-subject-triggered reloads

@Component({
    selector: 'app-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.css'],
    imports: [CommonModule],
    providers: [Destroy]
})
export class FaqsComponent implements OnInit {
  @ViewChild("el", {read: ElementRef}) el!: ElementRef;
  faqs: any;
  expandedIndex: number | undefined;
  types: string[] = ['REQUEST','ACCOUNT','SERVICES','CANCELLATION','PAYMENT'];
  selectedType: string = 'REQUEST';

  constructor(private commonService: CommonService, private destroy$: Destroy) {
  }

  ngOnInit(): void {
    // Do not auto-fetch on init to avoid repeated API calls.
    // FAQs will be fetched when the user clicks a chip (see template click handlers).
    this.getFaqs(this.types[0])
  }

  getFaqs(type: string) {
    this.selectedType = type;
    this.commonService.getFaqs("1", type).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.faqs = data.data || [];
      this.expandedIndex = undefined;
    })
  }

  toggleItem(index: any) {
    this.expandedIndex = this.expandedIndex === index ?  undefined :  index;
  }
}
